export default __webpack_public_path__ + "static/media/teamwork-lower.19641f1b.png";